import { render } from "./componentPopupSingleTop.vue?vue&type=template&id=35d17ef3&scoped=true"
import script from "./componentPopupSingleTop.vue?vue&type=script&lang=js"
export * from "./componentPopupSingleTop.vue?vue&type=script&lang=js"

import "./componentPopupSingleTop.vue?vue&type=style&index=0&id=35d17ef3&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d17ef3"]])

export default __exports__